import React from 'react'
import theme from 'vars/theme'
import { SpTitle } from './SpTitle'

type SpFrameProps = {
  title: string
  children?: React.ReactNode
  dataDgId?: string
}

export const SpFrame = ({ title, children, dataDgId }: SpFrameProps) => {
  return (
    <div
      className="p-4"
      style={{ borderRadius: 12, backgroundColor: theme.whitePrimary }}>
      <div className="d-flex flex-column justify-content-center">
        <SpTitle dataDgId={dataDgId}>{title}</SpTitle>

        {children}
      </div>
    </div>
  )
}
